import { City } from 'providers/cities';

export const formatCityName = (city: City) => {
  return city.cityName.split(',')[0];
};
